function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.457 12.309l.013.013a1.984 1.984 0 01.241.322l.021.035 10 17.321.008.014A1.991 1.991 0 0136 31a1.99 1.99 0 01-.38 1.174l-.037.048a3.13 3.13 0 01-.127.15 2.877 2.877 0 01-.184.171c-.01.01-.021.018-.033.027a2.243 2.243 0 01-.207.143l-.032.02-.014.007a1.987 1.987 0 01-.798.252l-.044.003a1.861 1.861 0 01-.176.005H14.032c-.059.001-.118 0-.177-.005L14 33a2.025 2.025 0 01-.43-.046 2.004 2.004 0 01-.556-.214L13 32.732l-.032-.019a2.002 2.002 0 01-.085-.054l.117.073a2.025 2.025 0 01-.584-.51l-.035-.048A1.99 1.99 0 0112 31v-.047a1.986 1.986 0 01.259-.939l.008-.014 10-17.32.02-.036a1.99 1.99 0 01.346-.426l-.027.026c.073-.071.152-.137.234-.195l.032-.022a1.985 1.985 0 01.662-.293l.02-.004c.04-.01.08-.018.12-.025l.025-.003c.038-.006.075-.01.113-.014l.034-.003a1.719 1.719 0 01.142-.006h.022a2 2 0 01.143.006l.034.003c.037.003.074.008.111.013l.026.005c.04.006.08.014.12.023l.02.005a2.017 2.017 0 01.662.292L25 11.947a2.025 2.025 0 01.393.297l-.027-.026.091.09zm5.078 16.69L23.999 17.68 17.464 29h13.071z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgHuge = function SvgHuge(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 48,
      height: 48
    }, props), _ref)
  );
};

export default SvgHuge;